import React from "react";
import Modal from "react-bootstrap/Modal";
import "../../assets/styles/local/TaskDelete.css";

const DeletePopUp = ({
  animation,
  handleDelete,
  show,
  onHide,
  title1,
  title2,
  title3,
  no,
  yes,
}) => {
  return (
    <Modal
      id="asc"
      animation={animation}
      show={show}
      onHide={onHide}
      size="md"
      aria-labelledby="contained-modal-title-vcenter"
      centered
    >
      <div className="text-center">
        <div>
          <p className="firstHead pt- m-0">{title1}</p>
          <p className="firstHead m-0">{title2}</p>
          <p className="proceed pt-2">{title3}</p>
        </div>

        <div className="d-flex justify-content-center flex-wrap gap-4 pt-5">
          <div className="btnNoDiv cursor-pointer" onClick={onHide}>
            <button className="btnNo p-2">{no}</button>
          </div>

          <div className="btnYesDiv cursor-pointer" onClick={handleDelete}>
            {/* yes */}
            <button className="btnYes p-2">{yes}</button>
          </div>
        </div>
      </div>
    </Modal>
  );
};

export default DeletePopUp;
